/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import isBoolean from 'lodash/isBoolean';
import type { Source } from '@atlassian/jira-forge-ui-types/src/common/types/analytics.tsx';
import type { Attributes } from '@atlassian/jira-product-analytics-bridge';
import getMeta from '@jira/platform__utils-get-meta/src/utils/get-meta/index.tsx';
import { isOverridingFragments } from '../environment/index.tsx';
import { getErrorType } from '../get-error-type/index.tsx';
import { isSynthetic } from '../synthetic/index.tsx';

export const parseSource = (source: Source): string =>
	source != null ? source.toString() : 'unknownSource';

export const transformError = (
	error: Error,
): {
	stack: string | undefined;
	message: string;
	name: string;
	cause?: unknown;
} => ({
	...error,
	stack: error.stack,
	message: error?.message,
});

export const createAttributes = (rawAttributes?: Attributes): Attributes => {
	const attributes: Attributes = {
		isSynthetic: isSynthetic(),
		isOverridingFragments: isOverridingFragments(),
		isSSR: __SERVER__,
		shard: getMeta('ajs-shard') || '',
		region: getMeta('ajs-region') || '',
	};

	if (rawAttributes) {
		const { source, error, hasForgeAccess } = rawAttributes;

		if (source) {
			attributes.source = parseSource(source);
		}

		if (error) {
			attributes.error = transformError(error);
			attributes.errorType = getErrorType(error);
		}

		if (isBoolean(hasForgeAccess)) {
			attributes.hasForgeAccess = hasForgeAccess;
		}
	}

	return { ...rawAttributes, ...attributes };
};
